module.exports = __webpack_public_path__ + "static/img/openvip_unVIP.b260608.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2/openvip_unVIP.png
// module id = Orzd
// module chunks = 1